import React, { useState, useEffect } from 'react';
import { FaHeart as EmptyHeart } from 'react-icons/fa';
import { FaHeart as FilledHeart } from 'react-icons/fa6';
import Lottie from 'lottie-react';
import elevateMartPlaceholder from '../assets/image_loading.json';
import ReactPixel from 'react-facebook-pixel';
import slugify from 'slugify';
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";

const ProductCard = ({ product, addToCart, toggleFavorite, isFavorite, cartItems, navigate }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const eventId = uuidv4();

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);

    if (product.image) {
      const img = new Image();
      img.src = product.image;
      img.onload = () => setImageLoaded(true);
      img.onerror = () => setImageError(true);
    }
  }, [product]);

  const inCart = cartItems.some(item => item.id === (product.productId || product.id));

  const handleBuyNowClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = { fbc, fbp, external_id: externalId };

    if (typeof window !== 'undefined' && window.fbq) {
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/track-addtocart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc, fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    }

    const cartItemForCheckout = {
      ...product,
      quantity: 1,
      selectedSize: product.sizes && product.sizes.length > 0 ? product.sizes[0] : null,
      selectedColor: product.colors && product.colors.length > 0 ? product.colors[0] : null,
    };

    if (navigate) {
      navigate('/checkout', {
        state: { cartItems: [cartItemForCheckout] }
      });
    }
  };

  const handleAddToCartClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = { fbc, fbp, external_id: externalId };

    if (typeof window !== 'undefined' && window.fbq) {
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/track-addtocart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc, fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    } else {
      console.warn('Facebook Pixel: AddToCart event not fired. fbq object is not available.');
    }
  };

  const handleCardClick = () => {
    const titleSlug = slugify(product.name, { lower: true, strict: true, trim: true });
    if (navigate) {
      navigate(`/product/${product.productId || product.id}/${titleSlug}`);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    toggleFavorite(product.id);

    if (!isFavorite(product.id)) {
      if (typeof window !== 'undefined' && window.fbq) {
        ReactPixel.track('AddToWishlist', {
          content_ids: [product.id],
          content_name: product.name,
          currency: 'BDT',
          value: product.price,
          content_type: 'product',
        });
      }
    }
  };

  const isLowStock = product.stock <= 10 && product.stock > 0;
  const isOutOfStock = product.stock === 0;

  return (
    <div
      onClick={handleCardClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="cursor-pointer flex flex-col h-full relative"
      style={{
        fontFamily: "'Segoe UI', Helvetica, 'Droid Sans', Arial, sans-serif",
        fontSize: '12px',
        color: '#615e58',
        padding: '5px',
        borderRadius: '6px',
        background: '#fff',
        lineHeight: 'normal',
      }}
    >
      {/* ── Image Area ── */}
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '1 / 1', background: '#F5D19D', borderRadius: '4px' }}>

        {/* Discount Badge */}
        {product.discount && (
          <div
            className="absolute top-2 left-2 z-10 text-white text-[10px] font-bold px-2 py-0.5 rounded"
            style={{ background: '#CD0302', fontSize: '10px' }}
          >
            {product.discount}
          </div>
        )}

        {/* Popular Badge */}
        {product.isPopular && (
          <div
            className={`absolute top-2 z-10 text-white text-[10px] font-bold px-2 py-0.5 rounded ${product.discount ? 'right-2' : 'right-2'}`}
            style={{ background: '#F88702', fontSize: '10px' }}
          >
            🔥 Popular
          </div>
        )}

        {/* Favorite */}
        <button
          onClick={handleFavoriteClick}
          className="absolute bottom-2 left-2 z-20 flex items-center justify-center"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          {isFavorite(product.id)
            ? <FilledHeart style={{ color: '#CD0302', fontSize: '16px' }} />
            : <EmptyHeart style={{ color: '#ccc', fontSize: '16px' }} />}
        </button>

        {/* Product Image */}
        {!imageLoaded && !imageError ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Lottie animationData={elevateMartPlaceholder} loop autoplay style={{ width: 80, height: 80 }} />
          </div>
        ) : (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover"
            style={{
              transform: isHovered ? 'scale(1.07)' : 'scale(1)',
              transition: 'transform 0.35s ease',
            }}
          />
        )}

        {/* Out-of-stock overlay */}
        {isOutOfStock && (
          <div className="absolute inset-0 flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.6)' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#CD0302', border: '1px solid #CD0302', padding: '2px 10px', borderRadius: '20px', background: '#fff' }}>
              Out of Stock
            </span>
          </div>
        )}

        {/* ── Add to Cart Button (bottom-right of image) ── */}
        {!isOutOfStock && (
          <button
            onClick={handleAddToCartClick}
            title={inCart ? 'In Cart' : 'Add to Cart'}
            className="absolute bottom-2 right-2 z-20"
            style={{
              width: '52px',
              height: '52px',
              borderRadius: '50%',
              background: inCart ? '#4F7E17' : '#fff',
              border: '2px solid #4F7E17',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(79,126,23,0.18)',
              transition: 'all 0.2s ease',
              flexShrink: 0,
            }}
            onMouseEnter={e => {
              if (!inCart) e.currentTarget.style.background = '#eef5e6';
            }}
            onMouseLeave={e => {
              if (!inCart) e.currentTarget.style.background = '#fff';
            }}
          >
            {inCart ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5 12.5L9.5 17L19 8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : (
              <svg width="28" height="28" viewBox="0 0 56 56" fill="none">
                <rect x="26.25" y="15.75" width="3.5" height="24.5" rx="1" fill="#4F7E17" />
                <rect x="40.25" y="26.25" width="3.5" height="24.5" rx="1" transform="rotate(90 40.25 26.25)" fill="#4F7E17" />
              </svg>
            )}
          </button>
        )}
      </div>

      {/* ── Card Body ── */}
      <div className="flex flex-col flex-grow pt-2 px-0.5" style={{ gap: '2px' }}>

        {/* Price Row */}
        <div className="flex items-baseline gap-1.5">
          <span style={{ fontSize: '14px', fontWeight: 700, color: '#4F7E17' }}>
            ৳{product.price}
          </span>
          {product.originalPrice && (
            <span style={{ fontSize: '11px', color: '#aaa', textDecoration: 'line-through' }}>
              ৳{product.originalPrice}
            </span>
          )}
        </div>

        {/* Product Name */}
        <p
          style={{
            fontSize: '12px',
            color: '#615e58',
            lineHeight: '1.4',
            margin: 0,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {product.name}
        </p>

        {/* Low Stock */}
        {!isOutOfStock && isLowStock && (
          <p style={{ fontSize: '10px', color: '#F88702', fontWeight: 600, margin: 0 }}>
            ⚡ Only {product.stock} left!
          </p>
        )}

      </div>
    </div>
  );
};

export default ProductCard;